import { Requirements } from 'app/routes';

import { Amounts, AvailablePromos, setAmounts, setAvailablePromos, setIsVacancyForeignArea } from 'store/autoReducers';
import {
    resetCampaignCreationWizard,
    setWizardSelectedVacancy,
    setWizardVacancies,
    setWizardVacancyFilters,
    WizardVacancy,
} from 'store/models/campaignCreationWizard';
import { resetMainMenuAllData } from 'store/models/mainMenu';
import { setRequisitesFilled } from 'store/models/requisites';

interface VacancyFiltersDto {
    areas: { id: number; name: string }[];
    users: { id: number; name: string }[];
}

const AdCreateMenuRequirements: Requirements<{
    existRequisites: { existRequisites: boolean };
    availablePromos: { availablePromoBonuses: AvailablePromos };
    depositAmount: Amounts;
    vacancies: WizardVacancy[];
    vacancyFilters: VacancyFiltersDto;
}> = {
    methods: () => ({
        existRequisites: { url: '/api/v1/requisites/exist_requisites', cacheable: false },
        availablePromos: { url: '/api/v1/promos/available', cacheable: false },
        depositAmount: { url: '/api/v1/catalog/depositAmount' },
        vacancies: { url: '/api/v1/vacancy/active_vacancies', timeout: 30000, cacheable: false },
        vacancyFilters: { url: '/api/v1/vacancy/active_vacancies/filters', timeout: 30000, cacheable: false },
    }),
    resolve: ({
        result: {
            existRequisites: { existRequisites },
            availablePromos: { availablePromoBonuses },
            depositAmount,
            vacancies,
            vacancyFilters,
        },
        historyState,
        state,
    }) => {
        const selectedVacancyId = historyState?.saveMainMenuData
            ? state.campaignCreationWizard.selectedVacancyId
            : null;
        const selectedVacancy = vacancies.find((vacancy) => vacancy.vacancyId === selectedVacancyId) ?? vacancies[0];

        return [
            ...(!historyState?.saveMainMenuData ? [resetMainMenuAllData(null), resetCampaignCreationWizard(null)] : []),
            setWizardVacancies(vacancies),
            setWizardSelectedVacancy(
                selectedVacancy
                    ? {
                          vacancyId: selectedVacancy.vacancyId,
                          vacancyName: selectedVacancy.name,
                          foreignArea: selectedVacancy.foreignArea,
                      }
                    : null
            ),
            setIsVacancyForeignArea(selectedVacancy?.foreignArea ?? false),
            setWizardVacancyFilters({
                areas: vacancyFilters.areas.map(({ id, name }) => ({ value: String(id), text: name })),
                users: vacancyFilters.users.map(({ id, name }) => ({ value: String(id), text: name })),
            }),
            setRequisitesFilled(existRequisites),
            ...(availablePromoBonuses ? [setAvailablePromos(availablePromoBonuses)] : []),
            setAmounts(depositAmount),
        ];
    },
};

export default AdCreateMenuRequirements;
